import { KalTableEventManager, KalTableEventParameter } from './kal-table-event-manager';


export class KalTablePage {
    // numéro de page
    number: number;
    // taille de page
    size: number;
}

export class KalTablePageEvent extends KalTablePage {
}

export class KalTablePageManager extends KalTableEventManager<KalTablePageEvent> {

    next(parameter: KalTableEventParameter = {}) {
        const {number, size} = this.value;
        this.set({
            number: number + 1,
            size
        }, parameter);
    }

    prev(parameter: KalTableEventParameter = {}) {
        const {number, size} = this.value;
        if (number > 0) {
            this.set({
                number: number - 1,
                size
            }, parameter);
        }
    }

    first(parameter: KalTableEventParameter = {}) {
        const {size} = this.value;
        this.set({
            number: 0,
            size
        }, parameter);
    }
}
